'use strict';

/** @type {Map<string, WebSocket>} */
const pendingByGameId = new Map();

/**
 * Stash an open game WebSocket for BattleUI to claim after navigate (History API cannot clone WebSocket).
 * @param {string} gameId
 * @param {WebSocket} socket
 */
export function stashGameSocket(gameId, socket) {
  if (!gameId) {
    throw new Error('stashGameSocket: gameId is required');
  }
  if (!socket || socket.readyState === WebSocket.CLOSED || socket.readyState === WebSocket.CLOSING) {
    throw new Error(`stashGameSocket: socket must be open for game ${gameId}`);
  }
  const existing = pendingByGameId.get(String(gameId));
  if (existing && existing !== socket && existing.readyState === WebSocket.OPEN) {
    throw new Error(`stashGameSocket: socket already stashed for game ${gameId}`);
  }
  pendingByGameId.set(String(gameId), socket);
}

/**
 * @param {string} gameId
 * @returns {WebSocket | null}
 */
export function takeGameSocket(gameId) {
  if (!gameId) {
    throw new Error('takeGameSocket: gameId is required');
  }
  const key = String(gameId);
  const socket = pendingByGameId.get(key);
  if (!socket) {
    return null;
  }
  pendingByGameId.delete(key);
  return socket;
}
